import React from "react";

function DexAggregatorHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  DEX Aggregator Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology specializes in developing powerful DEX
                    aggregators that streamline decentralized trading by
                    connecting users with the best liquidity and optimal prices
                    across multiple decentralized exchanges (DEXs)!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DexAggregatorHero;
